import React from "react";
import press from "../img/press.webp";
import nikkei from "../img/nikkei.webp";

function Press() {
  return (
    <div
      className="w-[100%] md:w-[100%] max-w-[1300px] mx-auto my-4 md:my-24"
      id="press"
    >
      <h2>メディア掲載実績</h2>
      <a
        target="_baink"
        rel="noopener"
        href="/nikkeitrendy.pdf"
        className="hover bg-[#F6C544] w-[100%] lg:h-auto gap-4 p-4 rounded-[10px] flex flex-col md:flex-row flex-wrap lg:flex-nowrap mt-4 md:mt-12"
      >
        <div className="bg-[#ffffff] w-[100%] lg:w-[64.5%] rounded-[10px] block text-left translate-y-2 md:translate-y-0 sm:order-2 lg:order-1">
          <div className="w-[95%] mx-auto py-2 md:py-4 px-2 md:px-12 text-[16px] md:text-[24px]">
            <p className="font-bold truncate ">
              日経トレンディ｜上半期注目インバウンド対策サービス
            </p>
            <p className="font-bold text-[#2F74B9] overflow-hidden h-[43%] my-1 md:my-2 line-clamp-3">
              「煩雑な手続き不要！小売店の強い味方に！！」
            </p>
            <p className="overflow-hidden md:block">
              伝統工芸品や日本酒など、日本特有の良さがある商品を簡単な手続きで、
              訪日外国人が購入した商品を世界各国に配送できる海外配送サービス「Beaver
              Delivery」
            </p>
          </div>
        </div>
        <div className="bg-[#ffffff] p-4 w-[100%] lg:w-[38%] rounded-[10px]  sm:order-1 lg:order-2">
          <img
            className="w-[100%]"
            src={nikkei}
            alt="酒販店"
            loading="lazy"
            width={331}
            height={190}
          />
        </div>
      </a>
      <a
        target="_baink"
        rel="noopener"
        href="https://jp.sake-times.com/special/pr/pr_beaver-delivery"
        className="hover bg-[#F6C544] w-[100%] lg:h-auto gap-4 p-4 rounded-[10px] mt-4 md:mt-8 flex flex-col md:flex-row flex-wrap lg:flex-nowrap"
      >
        <div className="bg-[#ffffff] w-[100%] lg:w-[64.5%] rounded-[10px] block text-left translate-y-2 md:translate-y-0 sm:order-2 lg:order-1">
          <div className="min-[1024px]:h-[90%] w-[95%] mx-auto py-2 md:py-4 px-2 md:px-12 text-[16px] md:text-[24px]">
            <p className="font-bold truncate ">
              SAKETIMES｜日本酒をもっと知りたくなるWEBメディア
            </p>
            <p className="font-bold text-[#2F74B9] overflow-hidden h-[43%] my-1 md:my-2 line-clamp-3">
              海外配送の効率化でインバウンドの日本酒購入を促進！ー白鶴酒造も導入した新サービス「Beaver
              Delivery」の魅力｜日本酒専門WEBメディア「SAKETIMES」
            </p>
            <p className="overflow-hidden md:block line-clamp-3">
              日本を訪れる海外観光客を対象に、酒蔵や酒販店から日本酒などの商品を自宅に送ることができる海外配送サービス「Beaver
              Delivery」が、2023年10月にスタートしました。
            </p>
          </div>
        </div>
        <div className="bg-[#ffffff] p-4 w-[100%] lg:w-[38%] rounded-[10px]  sm:order-1 lg:order-2">
          <img
            className="w-[100%]"
            src={press}
            alt="酒販店"
            loading="lazy"
            width={331}
            height={190}
          />
        </div>
      </a>
    </div>
  );
}

export default Press;
